import { useContext } from 'react';
import RootContext from './RootContext';

const useRootContext = () => useContext(RootContext);

export default useRootContext;
